module.exports = __webpack_public_path__ + "static/media/logout.f8fe78a6.svg";